'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var sidePanel = require('./side-panel');

var savedGalleries = [];
var galleryFavorites = {};
var pendingFavorite = {};

var isFavorite = function(photoId) {

	return galleryFavorites['' + photoId];

};

var toggleFavorite = function(photoId, favoriteState) {

	var key = '' + photoId;
	var curSetting = galleryFavorites[key];
	var newSetting = typeof favoriteState === 'undefined' ? !curSetting : favoriteState;

	galleryFavorites[key] = newSetting;

};

var storeGalleryFavorites = function(galleryIndex, galleryData, isFavoritesGallery) {

	if (!savedGalleries[galleryIndex] || isFavoritesGallery) {

		// We haven't saved favorites for this gallery yet. We only want to
		// save the favorites for a gallery the first time, so we don't
		// overwrite data that may have changed since this data was returned.
		// Favorites gallery data is always fresh from the server, so we always
		// want to save that.

		savedGalleries[galleryIndex] = true;

		galleryData.forEach(function(imgMeta) {

			toggleFavorite(imgMeta.photoId, imgMeta.isFavorite);

		});

	}

};

var updateFavoriteSetting = function(imageIndex, photoId) {

	var page = isFavorite(photoId) ? 'remove_favorite' : 'save_favorite';

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=' + page,
		dataType: 'JSON',
		data: {
			photoId: photoId
		}

	}).done(function(response) {

		var wasAdded = response.status.detail === 'favorite_added';
		var wasRemoved = response.status.detail === 'favorite_removed';

		if (wasAdded || wasRemoved) {

			toggleFavorite(photoId, wasAdded ? true : false);

			triggerCustomEvent('favorite_count_updated', {
				data: {
					count: response.favoriteCount
				}
			});

		}

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response,
				imageIndex: imageIndex
			}
		});

	});

};

var storePendingFavoriteData = function(imageIndex, photoId) {

	pendingFavorite.imageIndex = imageIndex;
	pendingFavorite.photoId = photoId;

};

var renderSendFavoritesForm = function() {

	$.ajax({

		url: dataMgr.getEventUrl() + '&page=load_send_favorites_form',
		type: 'POST',
		dataType: 'JSON'

	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var sendFavorites = function($form) {

	$form.find('.send-favorites-form__send-btn').text(window.pbizServer.content.loading);

	$.ajax({

		url: dataMgr.getEventUrl() + '&page=send_favorites',
		type: 'POST',
		dataType: 'JSON',
		data: $form.serialize()

	}).done(function(response) {

		$form.find('.send-favorites-form__send-btn').text(window.pbizServer.content.send);

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};


var showSendFavoritesSuccess = function() {

	$.ajax({

		url: dataMgr.getEventUrl() + '&page=send_favorites_success',
		type: 'POST',
		dataType: 'JSON'

	}).done(function(response) {

		sidePanel.open(response.markup);

	});

};


var addEventHandlers = function() {

	appDom.document.on('gallery_data_ready', function() {
		appDom.app.toggleClass('app--is-favorites', dataMgr.isFavoritesGallery());
	});

	appDom.document.on('gallery_data_saved', function(e, data) {

		storeGalleryFavorites(data.galleryIndex, data.galleryData, data.isFavoritesGallery);

	});

	appDom.document.on('image_grid_favorite_btn_clicked slideshow_favorite_btn_clicked', function(e, data) {

		storePendingFavoriteData(data.imageIndex, data.photoId);

		updateFavoriteSetting(data.imageIndex, data.photoId);

	});

	appDom.document.on('contact_login_success', function(e, data) {

		var responseData = data.response;
		var favoriteIds = responseData.favorites.toString().split(',');

		favoriteIds.forEach(function(id) {

			toggleFavorite(id, true);

		});

		triggerCustomEvent('favorites_updated_via_login');

		triggerCustomEvent('favorite_count_updated', {
			data: {
				count: responseData.favoriteCount
			}
		});

	});

	appDom.document.on('add_favorite', function() {

		updateFavoriteSetting(pendingFavorite.imageIndex, pendingFavorite.photoId);

	});

	appDom.document.on('main_nav_send_favorites_clicked load_send_favorites_form', function() {

		renderSendFavoritesForm();

	});

	appDom.document.on('click', '.js-render-send-favorites-form', function() {
		renderSendFavoritesForm();
	});

	appDom.document.on('click', '.send-favorites-form__send-btn', function(e) {

		e.preventDefault();

		sendFavorites($(this).closest('form'));

	});

	appDom.document.on('send_favorites_form_loaded', function(e, data) {

		sidePanel.open(data.response.markup, {type: 'send-favorites'});

	});

	appDom.document.on('favorites_message_invalid', function(e, data) {

		var $el = $('.send-favorites-form__message');

		notify.show({
			target: $el,
			container: '.send-favorites-form',
			msg: data.response.status.msg
		});

	});

	appDom.document.on('favorites_email_invalid', function(e, data) {

		var $el = $('.send-favorites-form__email');

		notify.show({
			target: $el,
			position: $el.hasClass('send-favorites-form__email--other-option') ? 'top' : 'bottom',
			container: '.send-favorites-form',
			msg: data.response.status.msg
		});

	});

	appDom.document.on('favorites_sent', function(e, data) {

		notify.hide();

		showSendFavoritesSuccess();

	});

	appDom.document.on('side_panel_opened', function(e, data) {

		if (data.panelType === 'send-favorites') {

			$('input[name="sendType"]:radio').change(function() {

				notify.hide();

				// affects the display/hiding of the email address input field
				$('.send-favorites-form').attr('data-send-type', $(this).val());

			});

		}

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init,
	isFavorite: isFavorite

};
